import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Course} from 'src/app/models/course.model';
import {AdminService} from 'src/app/services/admin.service';
import {CourceService} from 'src/app/services/cource.service';
import {CourseCategoryService} from 'src/app/services/course-category.service';
import {Subscription} from 'rxjs';
import {CourseCategory} from 'src/app/models/course-category.model';


@Component({
  selector: 'app-course-details',
  templateUrl: './course-details.component.html',
  styleUrls: ['./course-details.component.css']
})
export class CourseDetailsComponent implements OnInit {

  course: Course;
  categorySubscription$: Subscription;
  categories: CourseCategory[] = [];
  showSpinner: boolean = true;
  public _SelectedYear: string | null = '';


  constructor(
    private courseService: CourceService,
    private route: ActivatedRoute,
    private router: Router,
    private adminService: AdminService,
    private categoryService: CourseCategoryService
  ) {
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this._SelectedYear = params.get('year');
    });

    this.categoryService.getAllCategorys();
    window.scrollTo(0, 0);
    this.categorySubscription$ = this.categoryService.courseCategorySubject$.subscribe(
      (response: CourseCategory[]) => {
        this.categories = response;
      },
      (error) => {
        console.log('An error occured: ' + error);
      }
    );
    const id = +this.route.snapshot.params['id'];
    this.courseService.getCourse(id).subscribe(
      (response: Course) => {
        let category_name = this.categories.find((cat: any) => cat.id.toString() === response.category_id?.toString());
        console.log('category name', category_name);
        this.course = response;
        console.log(response);
        if (category_name) {
          this.course.category_name = category_name.name;
        }
        console.log(response)
        this.showSpinner = false;
      }
    );
  }

  isAdmin() {
    return this.adminService.isLoggedIn()
  }

  editCourse() {
    this.router.navigateByUrl(`/courses/${this.course.id}/edit`);
  }

  deleteCourse(course: Course) {
    this.courseService.courses = this.courseService.courses.filter(x => x.id !== course.id);
    this.courseService.emitCourseSubject();
    this.router.navigate(['/courses']);
  }

  inscription(course_id: number) {
    this.router.navigateByUrl(`/inscription/${course_id}`);
  }


  public returnToArchive(): void {
    if (this._SelectedYear) {
      this.router.navigate(['/archiv/program'], {queryParams: {year: this._SelectedYear}});
      return
    }
    this.router.navigate(['/program']);
  }

}
